import React from "react";
import { Text, Tooltip } from "@shopify/polaris";
import type { EditablePurchaseOrderLineItem } from "../../../api_utils/types";
import MinOrMinimumOrderQuantityCalculation from "./min_or_minimum_order_quantity_calculation";

const recommendationsSkeleton = (
  <Tooltip content="Please wait while we finish importing your store">
    <span>-</span>
  </Tooltip>
);

export default function NiceSalesRateRecommendation({
  purchaseOrderLineItem,
  readyForRecommendations,
}: {
  readonly purchaseOrderLineItem: EditablePurchaseOrderLineItem;
  readonly readyForRecommendations: boolean;
}): React.JSX.Element | string {
  const {
    sales_quantity,
    currently_available,
    relevant_purchase_order_quantity,
    recommended_quantity,
    needed,
  } = purchaseOrderLineItem;
  let calculation: React.ReactNode;
  if (recommended_quantity > 0 && recommended_quantity !== needed) {
    calculation = <MinOrMinimumOrderQuantityCalculation purchaseOrderLineItem={purchaseOrderLineItem} />;
  } else {
    calculation = (
      <>
        <Text as="strong">Est. calculation</Text>
        <Text as="p">&nbsp;&nbsp;&nbsp;{sales_quantity || 0} sales this time last year</Text>
        <Text as="p">- {currently_available} currently available</Text>
        <Text as="p">- {relevant_purchase_order_quantity || 0} ordered</Text>
        <Text as="p">= {recommended_quantity} recommended</Text>
        <br />
        <Text as="p">Note: Exact recommendations may vary based on other factors.</Text>
      </>
    );
  }

  return readyForRecommendations ? (
    <Tooltip content={calculation} preferredPosition="above">
      <Text as="strong">{recommended_quantity}</Text>
    </Tooltip>
  ) : (
    recommendationsSkeleton
  );
}
